import { getGridDataByModuleKey } from '../../../redux/selector';
import { useSelector } from 'react-redux';

const CustomSelectedRowCount = (props) => {
  const { api, context } = props;
  const moduleKey = context?.moduleKey;
  const gridDataSelection = useSelector(getGridDataByModuleKey('selectionList'));
  const fullSelection = Object.values(gridDataSelection?.[moduleKey] || {}).flat();
  console.log('🚀 ~ CustomSelectedRowCount ~ fullSelection:', fullSelection);
  const totalCount = fullSelection.length;
  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <span>Selected Count: {totalCount}</span>
    </div>
  );
};

export default CustomSelectedRowCount;
